import React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { Box, Grid } from '@mui/material';
import ProjectSidebar from './ProjectSidebar';

const ProjectLayout = () => {
  const params = useParams();
  const projectId = params.project || params.id;

  const isNew = !projectId || projectId === 'new';

  return (
    <Box>
      <Grid container spacing={4}>
        {!isNew && (
          <Grid item xs={12} md={3}>
            <ProjectSidebar />
          </Grid>
        )}
        <Grid item xs={12} md={isNew ? 12 : 9}>
          <Outlet />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProjectLayout;
